import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';

import {
  useNewbuildingBuzzoolaFirstEnabled,
  useNewbuildingBuzzoolaIntegrationAsStubEnabled,
  useNewbuildingBuzzoolaIntegrationTestWebBuzzoolaGroup,
  useNewbuildingBuzzoolaIntegrationTestWebExpEnabled,
} from '../../../../../utils/useNewbuildingBuzzoolaIntegrationTestWebAvailable';
import { BuzzoolaBannerContainer } from '../../../../BuzzoolaBanner';
import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import { AdfoxContextProvider, TAdfoxContextProviderProps } from '../../context/AdfoxContext';

/**
 * @todo Заменить типы
 * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
 * Если переходим на базуллу, то заменить на типы базуллы.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const POST_VIEW_ANALYTICS_DATA: TAdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
  place__DEPRECATED: 'CardKP',
  name__DEPRECATED: 'CardKP_Footer_TGB',
};
/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
 * Если переходим на базуллу, то удалить.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const P_PARAMS: TAdfoxContextProviderProps['pParams'] = { p1: 'ddcga', p2: 'fkhj' };
/**
 * @todo Заменить типы
 * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
 * Если переходим на базуллу, то заменить на типы базуллы.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const SIZE: TAdfoxContextProviderProps['size'] = { width: '100%', height: 276 };
/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
 * Если переходим на базуллу, то оставить как есть.
 * Если остаёмся на адфоксе, то удалить.
 */
const PLACEMENT_ID = 1299023;

/**
 * @todo Удалить компонент
 * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
 */
const TGBBannerExp: React.FC = () => {
  const isBuzzoolaGroup = useNewbuildingBuzzoolaIntegrationTestWebBuzzoolaGroup();

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
   * Если переходим на базуллу, то этот компонент с этипи пропсами переносим в TGBBanner.
   * Если не переходим, то просто всё в этом компоненте удалится.
   */
  if (isBuzzoolaGroup) {
    return (
      <BuzzoolaBannerContainer
        hideOnError
        hideOnNoad
        placementId={PLACEMENT_ID}
        sizes={SIZE}
        analyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    );
  }

  return (
    <AdfoxContextProvider
      bannerPlace="bottom"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    >
      <AdfoxBannerContainer />
    </AdfoxContextProvider>
  );
};

/**
 * @todo Удалить компонент
 * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
 */
const TGBBannerStub: React.FC = () => {
  const { state, setTrue } = useBooleanState(false);

  if (state) {
    return (
      <BuzzoolaBannerContainer
        hideOnError
        hideOnNoad
        placementId={PLACEMENT_ID}
        sizes={SIZE}
        analyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    );
  }

  return (
    <AdfoxContextProvider
      bannerPlace="bottom"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    >
      <AdfoxBannerContainer onStub={setTrue} />
    </AdfoxContextProvider>
  );
};

export const TgbBottomBannerContainer: React.FC = () => {
  const isBuzzoolaExpEnabled = useNewbuildingBuzzoolaIntegrationTestWebExpEnabled();
  const isBuzzoolaAsStubEnabled = useNewbuildingBuzzoolaIntegrationAsStubEnabled();
  const isBuzzoolaFirstEnabled = useNewbuildingBuzzoolaFirstEnabled();

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
   * Если переходим на базуллу, то выносим компонент базуллы BuzzoolaBannerContainer сюда,
   * ветвление в любом случае удаляется, компонента TGBBannerExp не должно быть.
   */
  if (isBuzzoolaExpEnabled) {
    return <TGBBannerExp />;
  }

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
   * Тут логику ветвления полностью убираем, так как тут просто включение базулы на постоянной основе, а результатом будет эксперимент,
   * это для того, что бы можно было включить баннеры для тестирования и подобных кейсов
   */
  if (isBuzzoolaFirstEnabled) {
    return (
      <BuzzoolaBannerContainer
        hideOnError
        hideOnNoad
        placementId={PLACEMENT_ID}
        sizes={SIZE}
        analyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    );
  }

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243386, будет удалён в задаче CD-245127
   * Тут удаляем в любом случае, так как это промежуточная логика пилота, этой логики по планам не будет в стабильном коде.
   * Будет или только адфокс или базулла.
   */
  if (isBuzzoolaAsStubEnabled) {
    return <TGBBannerStub />;
  }

  return (
    <AdfoxContextProvider
      bannerPlace="bottom"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    >
      <AdfoxBannerContainer />
    </AdfoxContextProvider>
  );
};
